import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import QualLeaderboardComponent from './js/qual-leaderboard.component';

ComponentsFactory.getInstance().define('qual-leaderboard', QualLeaderboardComponent);
